<template>
  <div class='TopUpQuery'>
    <Tab :Tab="tab"></Tab>
    <search-form size='medium'
                 labelWidth='90px'
                 class="SearchForm"
                 :searchData="search.searchData"
                 :searchForm="search.searchForm"
                 :searchHandle="search.searchHandle">
    </search-form>

    <Table :TableParam="Table">
      <template v-slot:handle="row">
        <el-link type="primary"
                 @click="()=>changeItem(row.item)">编辑</el-link>
        <el-divider direction="vertical"></el-divider>
        <el-link type="danger"
                 @click="()=>removeItem(row.item)">删除</el-link>
      </template>
      <template v-slot:Paging>
        <Paging @change="getItemList"
                :pager="pager" />
      </template>
    </Table>

    <service-dialog :show.sync="addDialog.show"
                    @handle="addDialog.confirm"
                    :title="addDialog.title"
                    v-if="addDialog.show">
      <template v-slot:dialogContent>
        <div class="addfrom">
          <el-form label-position="right"
                   label-width="120px"
                   ref="ruleForm"
                   :rules="addDialog.rules"
                   :model="addDialog.addFrom">
            <el-form-item label="账户类型："
                          prop="cardType">
              <el-select v-model="addDialog.addFrom.cardType"
                         clearable
                         placeholder="请选择账户类型">
                <el-option v-for="item in addDialog.cardType"
                           :key="item.id"
                           :label="item.name"
                           :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="手续费："
                          prop="rate"
                          :required="true">
              <el-input v-model="addDialog.addFrom.rate">
                <template slot="append"> ‰</template>
              </el-input>
            </el-form-item>

            <el-form-item label="有效期："
                          prop="validTime"
                          :required="true">
              <el-date-picker v-model="addDialog.addFrom.validTime"
                              type="daterange"
                              range-separator="至"
                              value-format="yyyy-MM-dd"
                              start-placeholder="开始日期"
                              end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="店铺："
                          prop="validTime"
                          v-if="tab.select == 1">
              <img :src="require('@/assets/u5844.png')"
                   class="uploadShop"
                   @click="listDialog.show = true">

              <div class="shopTags">
                <el-tag closable
                        type="info"
                        class="shopTab"
                        v-for="(tag,index) in listDialog.names"
                        :key="index"
                        @close="closeTag(tag)">
                  {{tag}}
                </el-tag>
              </div>
            </el-form-item>
          </el-form>
        </div>
      </template>
    </service-dialog>

    <service-dialog :show.sync="listDialog.show"
                    @handle="listDialog.confirm"
                    :title="listDialog.title">
      <template v-slot:dialogContent>
        <div class="content">

          <div class="floor">
            <!-- <el-tabs v-model="listDialog.floorName"
                     @tab-click="cutFloor">

              <el-tab-pane v-for="floor in listDialog.floorData"
                           :key="floor.name"
                           :label="floor.name"
                           :name="floor.name"> -->
                <div class="floorlist">
                  <ul>
                    <li 
                      v-for="floor in listDialog.floorData" 
                      :class="floor.name === listDialog.floorName ? 'active' : ''" 
                      @click="cutFloor(floor)"
                      :key="floor.name">
                      {{ floor.name }}
                      </li>
                    </ul>
                </div>
                <div class="storeFormat">
                  <span
                    v-for="storeFormatItem in storeFormat" 
                    :key="storeFormatItem.name" 
                    @click.stop="storeFormatChange(storeFormatItem.name)"
                    :class="{storeFormatActive:storeFormatActive===storeFormatItem.name}">
                      {{storeFormatItem.name}}
                  </span>
                  <div class="storeName">
                    <span>搜索店铺：</span>
                    <el-input
                      style="width: 165px;"
                      placeholder="输入店铺号或名称"
                      clearable
                      @keyup.enter.native="storeSearch"
                      v-model="storeName">
                    </el-input>
                  </div>
                </div>
                <div class="selectFloor">
                  <el-checkbox-group v-model="listDialog.checkedShops">
                    <el-checkbox v-for="shop in listDialog.shopData"
                                 :label="`${shop.id}&&${shop.shopName}`"
                                 :key="shop.id">
                                 <!-- <span :title="shop.shopName" class="textOverflow">{{shop.shopName}}</span> -->
                                 <span :title="shop.shopName" class="textOverflow">
                                   {{shop.shopName}}
                                   <div style="overflow: hidden;text-overflow: ellipsis;" :title="shop.shopCode">{{shop.shopCode}}</div>
                                 </span>
                    </el-checkbox>
                  </el-checkbox-group>
                </div>
                
              <!-- </el-tab-pane>
            </el-tabs> -->
            
          </div>
        </div>
      </template>
    </service-dialog>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import Tab from '@/components/Tab.vue'
import SearchForm from '@/components/SearchForm'
import Table from '@/components/Table'
import serviceDialog from '@/components/Dialog'
import Paging from '@/components/Paging'
import { handleCofirm } from '@/utils'
const typeProps = { label: 'name', value: 'id' }
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {
    Tab,
    SearchForm,
    Table,
    Paging,
    serviceDialog
  },
  data () {
    // 这里存放数据
    return {
      pager: { // 翻页
        page: 1,
        rows: 10,
        count: 0
      },
      asyncData: {
        floorShops: null
      },
      tab: {
        select: '0',
        pages: [
          {
            name: '通用规则设置',
            id: '0'
          },
          {
            name: '例外店铺规则设置',
            id: '1'
          }
        ],
        handle: () => this.cutPages()
      },

      search: { // 搜索
        searchData: {
          interst: []
        }, // 返回的数据
        searchForm: [
          { type: 'Select', label: '账户类型：', prop: 'cardTypeId', options: [], props: typeProps, change: row => '', placeholder: '请选择账户类型' }, {}
        ],
        searchHandle: [
          { label: '查询', type: 'primary', handle: () => this.searchHandleForm() }
        ]
      },

      Table: { // 表格
        primaryBtn: {
          show: true,
          html: '添加',
          handle: () => { this.addDialog.show = true; this.addDialog.title = '新建' }
        },
        handle: true,
        data: [],
        TabColumn: [
          [
            { prop: 'cardType', label: '账户类型' },
            { prop: 'rate', label: '手续费（‰）' },
            { prop: 'validDate', label: '有效期' }
          ],
          [
            { prop: 'cardType', label: '账户类型' },
            { prop: 'rate', label: '手续费（‰）' },
            { prop: 'validDate', label: '有效期' },
            { prop: 'excShops', label: '例外店铺' }
          ]
        ],
        column: []
      },
      
      storeFormatActive: '全部',
      storeFormat:[
        { name: '零售'},
        { name: '餐饮'},
        { name: '文娱'},
        { name: '服务'},
        { name: '其他'},
        { name: '全部'},
      ],
      storeName:'',

      addDialog: { // 新建
        show: false,
        title: '新建',
        confirm: this.addDialogConfirm,

        cardType: [],
        rules: {
          cardType: [
            { required: true, message: '请选择账户类型' }
          ],
          validTime: [
            { required: true, message: '请选择有效期' }
          ],
          rate: [
            { required: true, message: '请输入手续费' }
          ]
        },
        addFrom: {
          cardType: null,
          validTime: [],
          rate: null
        }
      },

      listDialog: { // 适用店铺
        show: false,
        title: '店铺',
        confirm: this.bindShops,
        ids: [],
        names: [],
        floorName: '全部', // 选中的楼层
        floorData: [], // 楼层数据
        shopData: [], // 店铺数据
        checkedShops: [] // 选中的数据
      }
    }
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {
    'addDialog.show': {
      handler (to) {
        if (!to) {
          this.$refs.ruleForm.resetFields()
          this.listDialog.checkedShops = []
          this.addDialog.addFrom = {
            cardType: null,
            validTime: [],
            rate: null
          }
          this.listDialog.names = []
          this.listDialog.ids = []
        }
      }
    },
    'listDialog.show': {
      handler (to) {
        // this.storeFormatActive = '全部'
        this.storeName=''
        this.cutFloor()
      }
    }
  },
  // 方法集合
  methods: {
    cutPages () { // 切换tab
      const { Table, tab } = this
      Table.column = Table.TabColumn[tab.select]
      Table.data = []
      this.searchResetForm() // 调用重置
      this.searchHandleForm()
    },
    // 查询
    searchHandleForm () {
      this.getItemList()
    },
    // 重置
    searchResetForm () {
      this.search.searchData = {}
    },
    // 添加 / 编辑 dialog确定按钮
    addDialogConfirm () {
      const { title, addFrom, uuid, id } = this.addDialog
      const { ids, names } = this.listDialog
      const [start, end] = addFrom.validTime
      const params = {
        cardTypeId: addFrom.cardType,
        rate: addFrom.rate,
        rateType: this.tab.select,
        beginDate: start || null,
        endDate: end || null
      }
      if (+this.tab.select) {
        params.shopCodes = ids.join(',')
        params.shopNames = names.join(',')
        if (!params.shopCodes) {
          return this.$message.warning('请选择店铺')
        }
      }
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          if (title === '新建') {
            this.addRate(params)
          } else if (title === '编辑') {
            params.uuid = uuid
            params.id = id
            this.changeRate(params)
          }
          this.addDialog.show = false
        } else {
          return false
        }
      })
    },

    // 移除 tag
    closeTag (tag) {
      const { ids, names, checkedShops } = this.listDialog
      const index = names.indexOf(tag)
      // 当移除tsg的时候需要保持数据同步
      names.splice(index, 1)
      ids.splice(index, 1)
      checkedShops.splice(index, 1)
    },
    // 删除行
    removeItem (row) {
      handleCofirm('确定要删除该行嘛?', 'type')
        .then(async () => {
          this.deleteRate(row.id)
        })
        .catch(() => { })
    },
    // 修改行
    async changeItem (row) {
      await this.getrateInfo(row.uuid)
      this.addDialog.title = '编辑'
      this.addDialog.uuid = row.uuid
      this.addDialog.id = row.id
      this.addDialog.show = true
    },
    // 切换楼层
    cutFloor (val = {name: '全部'}) {
      this.listDialog.floorName = val.name
      const floorName = this.listDialog.floorName
      const floorShops = this.asyncData.floorShops

      floorShops.forEach((item) => {
        if (item.floor === floorName) {
          this.listDialog.shopData = item.shops
        }
      })
      this.storeFormatActive = '全部'
      this.storeName=''
    },

    // 筛选所属行业数据
    changeFloorCheckData(name){
      const floorName = this.listDialog.floorName
      const floorShops = this.asyncData.floorShops
      floorShops.forEach((item) => {
        if (item.floor === floorName) { 
            this.listDialog.shopData = item.shops
          }
        })
        if(name!=='全部'){
          this.listDialog.shopData = this.listDialog.shopData.filter(item=>{
            return item.businessName === name
          })
        }
    },
    // 切换行业
    storeFormatChange(name) {
      this.storeName=''
      this.storeFormatActive=name
      this.changeFloorCheckData(name)
    },

    // 商店搜索
    storeSearch () {
      if(this.storeName!==''){
         this.changeFloorCheckData(this.storeFormatActive)
         this.listDialog.shopData = this.listDialog.shopData.filter(item=>{
            return (item.shopName.indexOf(this.storeName) !==-1) || (item.shopCode.indexOf(this.storeName) !==-1) || (this.storeName.indexOf(item.shopName) !== -1) || (this.storeName.indexOf(item.shopCode) !==-1)
          })
      }else{
        this.changeFloorCheckData(this.storeFormatActive)
      }
    },

    // 绑定店铺
    bindShops () {
      this.listDialog.ids = []
      this.listDialog.names = []
      this.listDialog.checkedShops.forEach((item) => {
        const [id, name] = item.split('&&')
        this.listDialog.ids.push(id)
        this.listDialog.names.push(name)
      })
      this.listDialog.show = false 
    },

    // 删除接口
    deleteRate (id) {
      const params = {
        id
      }
      this.$http.deleteRate(params)
        .then((res) => {
          if (res.status === 200) {
            this.$message.success(res.msg)
            this.getItemList()
          }
        })
    },

    // 修改接口
    changeRate (params) {
      this.$http.changeRate(params)
        .then((res) => {
          if (res.status === 200) {
            this.$message.success(res.msg)
            this.getItemList()
          } else {
            this.$message.error(res.msg)
          }
        })
    },

    // 获取详情接口
    async getrateInfo (id) {
      const { addFrom } = this.addDialog
      const { listDialog } = this
      const params = {
        id
      }
      await this.$http.getrateInfo(params)
        .then((res) => {
          if (res.status === 200) {
            addFrom.cardType = res.data.cardTypeId
            addFrom.rate = res.data.rate
            addFrom.validTime = [res.data.beginDate, res.data.endDate]
            if (+this.tab.select) {
              listDialog.names = res.data.shopNames
              listDialog.ids = res.data.shopCodes
              // 因为当初存储的时候即需要 店铺名字，又需要店铺id，所以进行了数据拼接
              listDialog.checkedShops = res.data.shopCodes.map((item, index) => {
                return `${item}&&${res.data.shopNames[index]}`
              })
            }
          }
        })
    },

    // 列表
    getItemList () {
      const { pager, search, tab, Table } = this
      const params = {
        pageNum: pager.page,
        pageSize: pager.rows,
        rateType: tab.select,
        ...search.searchData
      }
      this.$http.getRatePage(params)
        .then((res) => {
          pager.count = res.data.total
          Table.data = (res?.data?.list || []).map((item) => ({
            ...item,
            validDate: `${item.beginDate} ~ ${item.endDate}`,
            excShops: item.shopNames ? `${item.shopName}${item.shopNames.length > 1 ? '...' : ''} (${item.shopNames.length})` : null
          }))
        })
    },
    // 添加接口
    addRate (params) {
      this.$http.addRate(params)
        .then((res) => {
          if (res.status === 200) {
            this.$message.success(res.msg)
            this.getItemList()
          } else {
            this.$message.error(res.msg)
          }
        })
    },
    // 账户类型
    getCardTypeList () {
      this.$http.getCardTypeList()
        .then((res) => {
          if (res.status === 200) {
            this.search.searchForm.forEach((item) => {
              if (item.label && item.label.includes('账户类型')) {
                item.options = res.data
                this.addDialog.cardType = res.data
              }
            })
          }
        })
    },
    // 获取楼层
    getFloorShopList () {
      this.$http.getFloorShopList()
        .then((res) => {
          if (res.status === 200) {
            let allShops = []   
            res.data.forEach(item=>{
              allShops = allShops.concat(item.shops)
            })
            this.asyncData.floorShops = res.data.concat({floor: '全部', shops: allShops})
            this.listDialog.floorName = '全部' 
            // this.asyncData.floorShops = res.data
            // this.listDialog.floorName = res.data[0].floor
            this.asyncData.floorShops.forEach((item) => {
              if (item.floor === this.listDialog.floorName) {
                this.listDialog.shopData = item.shops
              }
              this.listDialog.floorData.push({ name: item.floor })
              const floorName = item.floor
              this.$set(this.listDialog.checkedShops, floorName, [])
            })
          }
        })
    },

    init () {
      this.getItemList()
      this.getCardTypeList()
      this.getFloorShopList()
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () {
    const { Table } = this
    this.Table.column = Table.TabColumn[0]
    this.init()
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {

  },
  beforeCreate () { }, // 生命周期 - 创建之前
  beforeMount () { }, // 生命周期 - 挂载之前
  beforeUpdate () { }, // 生命周期 - 更新之前
  updated () { }, // 生命周期 - 更新之后
  beforeDestroy () { }, // 生命周期 - 销毁之前
  destroyed () { }, // 生命周期 - 销毁完成
  activated () { } // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
.SearchForm {
  margin-top: -50px;
}
.floor {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .floorlist ul{
        margin: 0;
        padding: 0;
      }
      .floorlist li {
        display: inline-block;
        width: 50px;
        cursor: pointer;
        margin-bottom: 10px;
        text-align: center;
      }
      .floorlist li.active{
        color: #5c6be8;
      }
  .el-tabs {
    width: 100%;
  }
  .storeFormat{
      margin-top: 20px;
      span{
        color: #303133;
        padding: 0 5px;
        cursor: pointer;
      }
      .storeName{
        margin-top: 15px;
      }
      .storeFormatActive{
        color: #5c6be8;
      }
    }
}
.el-checkbox {
  width: 25%;
  margin-right: 0;
  &:nth-child(n + 4) {
    margin-top: 20px;
  }
}
.selectFloor {
  margin-top: 20px;
  ::v-deep .el-checkbox__label{
    vertical-align: text-top;
  }
}
.addfrom {
  padding: 0 60px;
  ::v-deep .el-range-editor.el-input__inner {
    width: 100%;
  }
  .uploadShop {
    width: 51px;
    height: 39px;
    display: block;
    cursor: pointer;
  }
  .shopTab {
    margin-top: 10px;
    margin-right: 10px;
    &:nth-child(3n + 3) {
      margin-right: 0;
    }
  }
}
.textOverflow {
  display: inline-block;
  width: 100px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>
